import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import api from '@/lib/api';
import { useStore } from '@/context/StoreContext';
import ProductCard from '@/components/common/ProductCard';
import { EmptyState } from '@/components/common/Loader';

export default function Wishlist() {
  const { wishlist } = useStore();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    if (wishlist.length) api.post('/products/by-ids', { ids: wishlist }).then((r) => setProducts(r.data)).catch(() => {});
    else setProducts([]);
  }, [wishlist]);

  return (
    <div className="container-gaze py-8">
      <h1 className="text-3xl font-semibold">My Wishlist</h1>
      <p className="mt-1 text-sm text-muted-foreground">{wishlist.length} saved items</p>
      {products.length === 0 ? (
        <EmptyState icon={Heart} title="Your wishlist is empty" subtitle="Tap the heart on any product to save it here." action={<Link to="/shop" className="mt-2 rounded-full bg-[hsl(var(--primary))] px-6 py-3 text-sm font-semibold text-white">Explore Products</Link>} />
      ) : (
        <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
